import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";

import {
    getHiddenfareRuleId,
    createHiddenFareRule,
    updateHiddenfare
} from "../../services/userservice";

const AddFareRule = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isEditMode, setIsEditMode] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({
        fare_identifier: "",
        vendor_type: "",
        type: "",
        status: "",
    });

    useEffect(() => {
        if (id && id !== "add") {
            setIsEditMode(true);
            fetchUserData(id);
        }
    }, [id]);

    const fetchUserData = async (id) => {
        setLoading(true);
        try {
            const response = await getHiddenfareRuleId(id);
            if (response) {
                setFormData({
                    fare_identifier: response?.fare_identifier || "",
                    vendor_type: response?.vendor_type || "",
                    type: response?.type || "",
                    status: response?.status || "",
                });
            }
        } catch (error) {
            setError(error.message || "Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const payload = { ...formData };

            if (isEditMode) {
                await updateHiddenfare(id, payload);
            } else {
                await createHiddenFareRule(payload);
            }

            navigate("/hidden-fare-rule-list");
        } catch (error) {
            setError(error.message || "Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">{isEditMode ? "Edit" : "Add"} Fare Type</h1>
                        </div>

                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    {isEditMode ? "Edit" : "Add"} Price Fare Rule
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <form onSubmit={handleSubmit}>
                                <div className="card">
                                    <div className="card-body">
                                        {error && (
                                            <div className="alert alert-danger">{error}</div>
                                        )}

                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label>Fare Identifier</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="fare_identifier"
                                                        value={formData.fare_identifier}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Fare Identifier"
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label>Category</label>
                                                    <select
                                                        className="form-control"
                                                        name="type"
                                                        value={formData.type}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select Category</option>
                                                        <option value="1">HOTEL</option>
                                                        <option value="2">FLIGHT</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label>Vendor Type</label>
                                                    <select
                                                        className="form-control"
                                                        name="vendor_type"
                                                        value={formData.vendor_type}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select Vendor Type</option>
                                                        <option value="1">TBO</option>
                                                        <option value="2">Tripjack</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label>Status</label>
                                                    <select
                                                        className="form-control"
                                                        name="status"
                                                        value={formData.status}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="active">Active</option>
                                                        <option value="inactive">Inactive</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card-footer">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? "Submitting..." : "Submit"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddFareRule;
